/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompletePrivacyRequestRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {CompletePrivacyRequestResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const completePrivacyRequest = (request:CompletePrivacyRequestRequest, options?: CashRequestOptions) => post<CompletePrivacyRequestRequest, CompletePrivacyRequestResponse>("/2.0/cash/complete-privacy-request", request, {...options, rejectOnError: true })